<template>
	<MenuItem v-slot="{ active }">
		<a
			v-if="isExternalLink"
			:href="to"
			target="_blank"
			:class="[
				active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
				'group flex items-center px-4 py-2 text-sm cursor-pointer'
			]">
			<font-awesome-icon
				v-if="icon"
				:icon="['fas', icon]"
				class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
				aria-hidden="true" />
			<slot />
		</a>
		<router-link
			v-else-if="to"
			:to="to"
			:class="[
				active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
				'group flex items-center px-4 py-2 text-sm cursor-pointer'
			]">
			<font-awesome-icon
				v-if="icon"
				:icon="['fas', icon]"
				class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
				aria-hidden="true" />
			<slot />
		</router-link>
		<button
			v-else
			type="button"
			:class="[
				active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
				'group flex w-full items-center px-4 py-2 text-sm'
			]"
			@click="$emit('click')">
			<font-awesome-icon
				v-if="icon"
				:icon="['fas', icon]"
				class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"
				aria-hidden="true" />
			<slot />
		</button>
	</MenuItem>
</template>

<script setup lang="ts">
	import { MenuItem } from '@headlessui/vue'
	import { computed } from 'vue'

	const props = defineProps<{
		icon?: string
		to?: string
	}>()

	defineEmits(['click'])

	const isExternalLink = computed(() => {
		return (
			typeof props.to === 'string' &&
			(props.to.startsWith('http') || props.to.startsWith('tel'))
		)
	})
</script>
